// extracted by mini-css-extract-plugin
var _1 = "editable-cell-negative___Fx3F7";
var _2 = "editable-cell-positive___w7FjT";
var _3 = "editable-cell-zero___x7VJp";
export { _1 as "editable-cell-negative", _2 as "editable-cell-positive", _3 as "editable-cell-zero" }
